export const tagsToFormFields: (tags: { id: number, name: string }[]) => string[] = (tags) => {
  return tags?.map(item => (
    JSON.stringify({
      label: item.name,
      value: item.id,
    })
  ))
}